var _rect, _rect2, _rect3, _rect4, _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInAppPurchases(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1.5,
    width: 14,
    height: 21,
    rx: 1.5,
    stroke: "#2E2E2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 2.75,
    width: 4.5,
    height: 0.5,
    rx: 0.25,
    stroke: "#2E2E2E",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 18.25,
    width: 13.5,
    height: 0.5,
    rx: 0.25,
    stroke: "#2E2E2E",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 1,
    height: 1,
    rx: 0.5,
    stroke: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2802 10.5177L9.88864 10.5177L9.27651 7.69952L15.5823 7.69952L15.1247 9.83502C15.0393 10.2332 14.6874 10.5177 14.2802 10.5177Z",
    stroke: "#C63031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5584 12.6897L10.7729 12.6897C10.5407 12.6897 10.3391 12.5299 10.2861 12.3038L8.84045 6.13614C8.78746 5.91008 8.58583 5.75024 8.35364 5.75024L7.5 5.75024",
    stroke: "#C63031"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 14.2502,
    r: 0.75,
    fill: "#C63031"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 14.2502,
    r: 0.75,
    fill: "#C63031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAppPurchases);
export default __webpack_public_path__ + "static/media/in-app-purchases.a3d031b045b74ceb050476f76c2da904.svg";
export { ForwardRef as ReactComponent };